<template>
    <div v-loading="loadingController">
        <p style="text-align:center;width:100%;padding:10px">
            <el-link 
            type="primary" 
            @click="showImg=true"
            style="font-size:18px">
                AB区分类说明
            </el-link>
        </p>
        <my-form 
        class="form-page" 
        v-model="form" 
        table
        label-width="180px">

            <el-form-item
            class="table-full-row"
            label="项目类别">
                <el-radio-group v-model="form.proclass" @change="changeProclass">
                    <el-radio label="1" border>经核准招标的审批（核准）项目</el-radio>
                    <el-radio label="2" border>备案类项目</el-radio>
                    <el-radio label="3" border>无需审批、核准、备案类</el-radio>
                </el-radio-group>
            </el-form-item>

            <el-form-item
            class="table-full-row"
            v-if="form.proclass!=='3'"
            label="项目级别">
                <el-radio-group v-model="form.level" @change="changeLevel">
                    <el-radio label="1" border>省级</el-radio>
                    <el-radio label="2" border>市级</el-radio>
                    <el-radio label="3" border>县（区）级</el-radio>
                </el-radio-group>
                <my-tag type="danger">
                    监管单位为省级单位，选择省级项目。监管单位为市级，选择市级项目。监管单位为县（区）级,选择县区级项目
                </my-tag>
            </el-form-item>

            <el-form-item
            class="table-full-row"
            v-if="form.proclass!=='3'"
            label="行业监管部门">
                <el-radio-group v-model="form.deptcode" @change="changeDeptcode">
                    <el-radio label="1" border>交通</el-radio>
                    <el-radio label="2" border>水利</el-radio>
                    <el-radio label="3" border>住建</el-radio>
                    <el-radio label="4" border>其他</el-radio>
                </el-radio-group>
                <my-tag type="danger">
                    注:如此项目需住建监管，必须选择住建。如此项目需推送至交通网，必须选择交通。
                </my-tag>
            </el-form-item>

            <el-form-item
            class="table-full-row"
            label="项目来源">
                <el-radio-group v-model="form.ly" @change="changeLy">
                    <el-radio label="1" 
                    v-if="form.proclass!=='3'" 
                    border>河北省投资项目在线审批监管平台
                    </el-radio>

                    <el-tooltip
                    class="item" 
                    effect="dark" 
                    v-if="form.proclass!=='3'" 
                    content="选择河北交通招投标网省级项目请输入核准号获取项目信息，市县级项目请在公共服务平台自主添加" 
                    placement="top">
                        <el-radio label="4" border>河北交通招投标网</el-radio>
                    </el-tooltip>

                    <el-radio 
                    label="3" 
                    border>自主添加
                    </el-radio>
                </el-radio-group>
            </el-form-item>

            <el-form-item
            class="table-full-row"
            prop="xmbm"
            :rules="newRule('项目代码','sensitiveWords')"
            v-if="form.proclass!=='3'&&form.ly==='1'"
            label="项目代码">

                <el-input 
                v-model="xmbm"
                style="width:50%">
                </el-input>

                <el-button 
                size="mini" 
                icon="el-icon-check" 
                type="primary" 
                @click="search"
                style="margin-left:10px">
                    确定
                </el-button>

                <p>
                    <el-link 
                    href="http://tzxm.hbzwfw.gov.cn/sbglweb/gsxxList?xzqh=130000" 
                    target="_blank"
                    type="primary">（进入在线审批监管平台查询）
                    </el-link>
                </p>
            </el-form-item>
            <el-form-item
            class="table-full-row"
            v-if="form.proclass!=='3'&&form.ly==='4'"
            label="核准文号">
                <el-input 
                v-model="xmbm"
                style="width:50%">
                </el-input>

                <el-button 
                size="mini" 
                icon="el-icon-check" 
                type="primary" 
                @click="search"
                style="margin-left:10px">
                    确定
                </el-button>
            </el-form-item>

            <el-form-item
            class="table-full-row"
            label="公告发布媒体">
                <el-checkbox-group v-model="checkList" @change="changecheck">
                    <el-checkbox disabled label="河北省招标投标公共服务平台"></el-checkbox>
                    <el-checkbox :disabled="form.proclass!=='3'" label="河北省公共资源交易中心"></el-checkbox>
                    <el-checkbox @change="hbzfcg" label="河北省政府采购网"></el-checkbox>
                    <el-checkbox disabled label="河北交通招投标网"></el-checkbox>
                </el-checkbox-group>
                
            </el-form-item>
            

            <template slot="btn">
                <el-button 
                @click="saveHandler()" 
                type="primary" 
                v-if="form.proclass==='3'||form.ly==='3'" 
                icon="el-icon-circle-check">
                    添加项目
                </el-button>
                <el-button 
                icon="el-icon-circle-close" 
                @click="$emit('cancle')">
                    取消
                </el-button>
            </template>
        </my-form>
        <div class="showImg" v-if="showImg">
            <i class="icon el-icon-circle-close" @click="showImg=false"></i>
            <img src="../assets/AB.png" alt="">
        </div>
    </div>
    
</template>

<script>
export default {
    data: () => ({
        form: {
            proclass:'1',
            level:'1',
            deptcode:'1',
            ly:'1',
        },
        checkList:['河北省招标投标公共服务平台','河北省公共资源交易中心',],
        showImg:false,

        xmlbcode:'100',
        prolevelcode:'1',
        hyjgbmcode:'0',
        ggzy:'1',
        iszfcg:'0',
        pt:'',
        xmbm:'',

        loadingController:false,
        pathname:'',
    }),
    watch: {
        'form.proclass':function(o,n){
            if(n==='3'){
                this.checkList.push('河北省公共资源交易中心');
            }
        },
    },
    computed: {
       
    },
    methods: {
        checkSensitiveWord(value){
            var that = this;
            var mgcRes = {};
            mgcRes = this.$store.getters.sensitiveWords;
            var type = false;//是否开启全词匹配
            var isEnd = false;
            if(!!value == false){
                return true;
            }
            for(var i = 0;i < value.length;i++){
                var curRes = mgcRes;
                if(!!curRes[value[i]]){
                    var num = 1;
                    for(var j = i + 1;j < value.length;j++){
                        curRes = curRes[value[j-1]];
                        if(!!curRes[value[j]]){
                            num++;
                            if(curRes[value[j]].isEnd == '1' && (type == false)){
                                //that.form[rules.field] = "";
                                return false;
                            }
                            if(curRes[value[j]].isEnd == '1'){
                                isEnd = true;
                            }
                        }else{
                            break;
                        }
                    }
                    if(num > 1 && isEnd){
                        //that.form[rules.field] = "";
                        return false;
                    }
                }
            }
            return true;
        },
        search(){
            var that = this
            if(!that.form.ly){
                ShowMsg('请选择项目来源','warning');
                return;
            }
            if(that.form.ly!=='3'){
                if(!that.xmbm&&that.form.ly==='1'){
                    ShowMsg('请填写项目编码','warning');
                    return;
                }else if(!that.xmbm&&that.form.ly==='4'){
                    ShowMsg('请填写核准文号','warning');
                    return;
                }
                if(that.form.ly==='1'){
                    var res = this.checkSensitiveWord(this.xmbm);
                    if(!res){
                        ShowMsg('包含敏感词汇','warning');
                        return;
                    }
                }
            }else{
                that.xmbm = '';
                that.hyjgbmcode = '';
            }
            //省级交通只能选省级交通
            if(that.form.ly==='4'){
                if(that.prolevelcode!=='1'||that.form.deptcode!=='1'){
                    ShowMsg('项目级别请选择省级，行业监管部门请选择交通','warning');
                    return;
                }
            }
            that.loadingController = true
            
            that.$post(`${this.getGetters('mngUrl')}/Zbdl/Project/search.json`,{
                pt:that.form.ly,
                xmbm:escape(that.xmbm),
                iszfcg:that.iszfcg,
                ggzy:that.ggzy
            }, data => {
                that.loadingController = false
                ShowConfirm('确定要添加' +data.proname + '吗？', 'primary', () => {
                    var url = ''
                    if(data.pageUrl==='/getProInfo/edit.do'){
                        url = 'getproinfoForm'
                    }else if(data.pageUrl==='/getsjjtxm/edit.do'){
                        url = 'getsjjtForm'
                    }
                    if(getSession('isRevision')!=1){
                        that.goto({
                            path: '/bidding/project/'+url,
                            query: {
                                xmly:that.form.ly,
                                xmbm:that.xmbm,
                                xmlbcode:that.xmlbcode,
                                prolevelcode:that.prolevelcode,
                                hyjgbmcode:that.hyjgbmcode,
                                iszfcg:that.iszfcg,
                                ggzy:that.ggzy,
                            }
                        });
                    }else{
                        window.top.$tagFrame.pushTag({
                            src:that.pathname+'?t='+Math.random()+`#/bidding/project/`+url+`?xmly=`+that.form.ly+'&xmbm='+that.xmbm+'&xmlbcode='+that.xmlbcode+'&prolevelcode='+that.prolevelcode+'&hyjgbmcode='+that.hyjgbmcode+'&iszfcg='+that.iszfcg+'&ggzy='+that.ggzy,
                            title:'添加建设工程项目',
                            type: 'href',
                            topparent:'common-tag',
                        })
                    }
                })
            })
          
        },
        // 点击河北省政府采购
        hbzfcg(){
            ShowMsgBox('同步政府采购网项目需在招标项目处添加政府采购计划编码！','warning')
        },
        changeProclass(){
            var that = this;
            if(that.form.proclass==='1'){
                that.xmlbcode = '100';
            }else if(that.form.proclass==='2'){
                that.xmlbcode = '101';
            }else{
                that.checkList.forEach(function(item,index){
                    if(item==='河北省公共资源交易中心'){
                        that.checkList.splice(index, 1);
                        that.ggzy = '0'
                    }
                })
                that.xmlbcode = '102';
            }
        },
        changeLevel(){
            this.prolevelcode = this.form.level;
            this.checkZtbw()
        },
        changeDeptcode(){
            this.checkZtbw()
            if(this.form.deptcode=='1'){
                this.hyjgbmcode = '0';
            }else if(this.form.deptcode=='2'){
                this.hyjgbmcode = '1';
            }else if(this.form.deptcode=='3'){
                this.hyjgbmcode = '4';
            }else{
                this.hyjgbmcode = '9';
            }
        },

        changecheck(){
            this.checkList.forEach(function(item){
                if(item==='河北省政府采购网'){
                    ShowMsgBox('同步河北省政府采购网项目需在招标项目处添加政府采购计划编码！', 'warning');
                }
                //是否选中公共资源
                if(item==='河北省公共资源交易中心'){
                    this.ggzy = '1'
                }else{
                    this.ggzy = '0'
                }
                // 是否选中河北省政府采购网
                if(item==='河北省政府采购网'){
                    this.iszfcg = '1'
                }else{
                    this.iszfcg = '0'
                }
            })
        },
        // 省招投标网判断选中
        checkZtbw(){
            var that = this
            // debugger
            if(that.form.deptcode==='1'){
                if(that.form.level!=='1'||(that.form.level==='1'&&that.form.ly==='4')){
                    var num = 0
                    that.checkList.forEach(function(item,index){
                        if(item==='河北交通招投标网'){
                           num = num + 1
                        }
                    }) 
                    if(num===0){
                        that.checkList.push('河北交通招投标网');
                    }
                    
                }else{
                    that.checkList.forEach(function(item,index){
                        if(item==='河北交通招投标网'){
                            that.checkList.splice(index, 1);
                        }
                    }) 
                }
            }else{
                that.checkList.forEach(function(item,index){
                    if(item==='河北交通招投标网'){
                        that.checkList.splice(index, 1);
                    }
                })
            }
        },
        // 项目来源
        changeLy(){
            this.checkZtbw()
        },
        // 添加项目
        saveHandler(){
            var that = this
            // that.pt = that.form.ly
            if(getSession('isRevision')!=1){
                that.goto({
                    path: '/bidding/project/form',
                    query: {
                        xmly:that.form.ly,
                        xmbm:that.xmbm,
                        xmlbcode:that.xmlbcode,
                        prolevelcode:that.prolevelcode,
                        hyjgbmcode:that.hyjgbmcode,
                        iszfcg:that.iszfcg,
                        ggzy:that.ggzy,
                    }
                });
            }else{
                window.top.$tagFrame.pushTag({
                    src:that.pathname+'?t='+Math.random()+`#/bidding/project/form?xmly=`+that.form.ly+'&xmbm='+that.xmbm+'&xmlbcode='+that.xmlbcode+'&prolevelcode='+that.prolevelcode+'&hyjgbmcode='+that.hyjgbmcode+'&iszfcg='+that.iszfcg+'&ggzy='+that.ggzy,
                    title:'添加建设工程项目',
                    type: 'href',
                    topparent:'common-tag',
                })
            }
            

            
        }
    },
    created() {
        this.pathname = window.location.pathname
      
    },
    mounted() {
        
    }
}
</script>

<style scoped lang="scss">
/deep/ .form-page{ width: 100%;}
.icon{
    cursor: pointer;
    font-size:36px;
    top:-15px;
    position: absolute;
    right: -15px;
}
.showImg{ 
    position: absolute; top: 50%;
    left: 50%;
    transform: translate(-50%,-20%);
}
.showImg img{ width: 1000px;}
/deep/ .table-view[data-v-3acdabe5] .el-form-item:not(.btn-row) .el-form-item__content{ padding: 10px;}
/deep/ .el-checkbox__input.is-disabled + span.el-checkbox__label{ color: #606266;}
</style>
